export default __webpack_public_path__ + "static/worker4-b1bb68e73dd9b68a4aa29f52dd69c396.jpg";